"use client";

import { Icon } from "@/components/ui/icon";
import { LinkButton } from "@/components/ui/link-button";
import { appendInvitationToken } from "@/lib/invitation-links";

type UnauthenticatedInviteActionsProps = {
  token: string;
  orgName: string;
};

export function UnauthenticatedInviteActions({
  token,
  orgName,
}: UnauthenticatedInviteActionsProps) {
  const signInHref = appendInvitationToken("/login", token);
  const registerHref = appendInvitationToken("/register", token);

  return (
    <div className="flex flex-col gap-4">
      <p className="text-sm text-contrast/70 leading-5">
        Sign in or create an account to join{" "}
        <span className="font-medium text-heading">{orgName}</span>.
      </p>
      <div className="flex flex-col gap-2">
        <LinkButton
          href={signInHref}
          variant="linear-ai"
          size="auth"
          className="rounded-sm"
        >
          Sign in <Icon name="IconArrowRight" size={16} />
        </LinkButton>
        <LinkButton
          href={registerHref}
          variant="light"
          size="auth"
          className="rounded-sm"
        >
          Create account <Icon name="IconArrowRight" size={16} />
        </LinkButton>
      </div>
    </div>
  );
}
